import { Directive, forwardRef, HostBinding } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { addAriaId, removeAriaId } from '../utils/a11y.util';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yTablist]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yTablistDirective) }]
})
export class A11yTablistDirective extends A11yLabelDirective {
  private readonly tabIds: string[] = [];
  private readonly panelIds: string[] = [];

  @HostBinding('attr.role') public readonly role = 'tablist';

  public registerTab(id: string): void {
    addAriaId(this.tabIds, id);
  }

  public unregisterTab(id: string): void {
    removeAriaId(this.tabIds, id);
  }

  public registerPanel(id: string): void {
    addAriaId(this.panelIds, id);
  }

  public unregisterPanel(id: string): void {
    removeAriaId(this.panelIds, id);
  }

  public getPanelIdForTab(tabId: string): string | null {
    const tabIndex = this.tabIds.indexOf(tabId);

    return tabIndex > -1 ? this.panelIds[tabIndex] ?? null : null;
  }

  public getTabIdForPanel(panelId: string): string | null {
    const panelIndex = this.panelIds.indexOf(panelId);

    return panelIndex > -1 ? this.tabIds[panelIndex] ?? null : null;
  }
}
